import { defineStore } from 'pinia'
import { ref, computed, reactive } from 'vue'

// `defineStore()`의 반환 값(함수)을 할당할 변수의 이름은 원하는 대로 지정할 수 있지만,
// 스토어 이름을 사용하고 `use`와 `Store`로 묶는 것이 가장 좋습니다.
// 예: `useUserStore`, `useCartStore`, `useProductStore`
// 첫 번째 인자는 앱 전체에서 스토어의 고유 ID입니다.
// ref()는 state 속성이 됨.
// computed()는 getters가 됨.
// function()은 actions가 됨.
export const useCommonStore = defineStore('common', () => {
  //탭 이동
  const tabName = ref('')
  const popupTabName = ref('')
  const isTabView1 = ref(false)
  const isTabView2 = ref(false)
  const isTabView3 = ref(false)
  const isTabView4 = ref(false)
  const tabType = ref('')
  const senderType = ref('')
  //팝업 오픈 시 사용되는 파라미터
  const popupIdx = ref('')
  const popupTitle = ref('')
  const popupContent = ref('')
  const popupParams = ref({})
  const popupType = ref('')
  const popupItems = ref([])
  const popupItems2 = ref([])
  const popupItemsExtra = ref([]) //선택안된항목 임의사용
  const moduleType = ref('')  //1:모니터링 2:리더십
  const popupInfo = ref({}) //게시글 전체정보 팝업으로 전달
  const popupInfo2 = ref({}) //팝업이 2중일경우
  const selectedTask = ref([])  //선택된 리더십 테스트
  const selectedContent = ref([]) //선택된 리더십 컨텐트
  const leadershipInfo = ref({})  //리더십 전체정보
  const leadershipMonitoringInfo = ref({})  //리더십 모니터링 전체정보
  const monitoringInfo = ref({})  //모니터링 전체정보
  //상세 오픈 시 사용되는 파라미터
  const viewIdx = ref('')
  //client 팝업 > adminList
  const adminList = ref([])
  //head정보
  const clientName = ref('')
  const companyName = ref('')
  //사용자정보
  const user = ref(null)
  //알람여부
  const isAlarm = ref(false)
  //언어
  const lang = ref('A')
  //언어리스트
  const langList = ref({})
  //타임라인타입
  const timelineType = ref('1')
  const timelineIdx = ref('')
  //모니터링 활동이력 탭 {{t('message.filter')}}
  const monitoringStartDate = ref('')
  const monitoringEndDate = ref('')
  const monitoringDept = ref('')
  //리포트의 리더십단계에서 제출한 파일리스트
  const fileList = ref([])
  //리더십 수행 관찰자모드
  const isObserver = ref(false)

  const moveTab=(tab:string)=> {
    tabName.value = tab
    if(tab === 'tabCont1')
      isTabView1.value = false
    else if(tab === 'tabCont2')
      isTabView2.value = false
    else if(tab === 'tabCont3')
      isTabView3.value = false
    else if(tab === 'tabCont4')
      isTabView4.value = false
  }

  const moveTabView=(tab:string)=> {
    tabName.value = tab
    if(tab === 'tabCont1')
      isTabView1.value = true
    else if(tab === 'tabCont2')
      isTabView2.value = true
    else if(tab === 'tabCont3')
      isTabView3.value = true
    else if(tab === 'tabCont4')
      isTabView4.value = true
  }

  return {
    tabName,
    popupTabName,
    isTabView1,
    isTabView2,
    isTabView3,
    isTabView4,
    tabType,
    senderType,
    moveTab,
    moveTabView,
    popupIdx,
    popupTitle,
    popupContent,
    popupType,
    moduleType,
    popupParams,
    viewIdx,
    popupInfo,
    popupInfo2,
    popupItems,
    popupItems2,
    popupItemsExtra,
    adminList,
    clientName,
    companyName,
    user,
    isAlarm,
    timelineType,
    monitoringStartDate,
    monitoringEndDate,
    monitoringDept,
    lang,
    langList,
    selectedTask,
    selectedContent,
    leadershipInfo,
    leadershipMonitoringInfo,
    monitoringInfo,
    fileList,
    isObserver,
    timelineIdx
  }
})
